<template>
  <button
    class="button button-compact button-solid"
    @click.prevent="scrollTo"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ZvScrollTop',
  methods: {
    scrollTo () {
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth',
      })
    },
  },
}
</script>
